import Title from './Title.webp';
import River from './River.webp';
import River2 from './River2.webp';
import MiniGame from './MiniGame.webp';
import Jump from './Jump.webp';
import Bonus from './Bonus.webp';

export default {
    Title,
    River,
    River2,
    MiniGame,
    Jump,
    Bonus
}